import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import NavTitle from "../../../components/nav-title";
import TextNavTitle from "../../../components/TextNavTitle";
import CardStyle from "../../../components/card";

import { cardStyleList } from "./style/locationStyles";
// import { containerStyle, cardStyleList } from "./style/locationStyles";
import {
  getLocationOrgs,
  downloadLocationOrgs,
} from "../../../services/setting/locations/location-list";
import GenericTable from "../../../components/table";
import { RxCopy } from "react-icons/rx";
import { HiOutlinePlus } from "react-icons/hi";
import { LuTable2 } from "react-icons/lu";

import {
  // columns,
  renderLocationRow,
  locationListFields,
} from "./data/locationListFields";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "../../../components/input/tab";
import FormField from "../../../components/input/form-field";
import { Button, Col, Row } from "react-bootstrap";
import { TbChevronDown } from "react-icons/tb";
import { Pagination, Select } from "antd";
import { PAGE_SETTING_LOCATION_ASSIGN } from "../../../router/routes";
import { updateRole } from "../../../actions/role-org.action";
import { useTranslation } from "react-i18next";
import LocationPOI from "./page/location.poi";

const Location = () => {
  const isMobile = window.innerWidth < 768
  const { orgRole, setOrgSelete } = useOutletContext();
  const { t } = useTranslation();
  const roleId = useSelector((state) => state.roleReducer.role);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  // const [activeTab, setActiveTab] = useState("general");
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeTab") || "general";
  });
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      searchList: "",
      selectOrgs: null,
    },
  });
  useEffect(() => {
    if (roleId && orgRole?.length) {
      const org = orgRole.find(
        (item) => String(item.org_id) === String(roleId),
      );

      if (org) {
        // set ให้ react-hook-form
        setValue("selectedOrg", {
          label: org.org,
          value: org.org_id,
        });

        // set ให้ outlet context (ถ้าจำเป็น)
        setOrgSelete?.(org);
      }
    }
  }, [roleId, orgRole, setValue, setOrgSelete]);

  const handleChangeOrg = (option) => {
    if (!option) return;
    dispatch(updateRole(option.value));
    const org = orgRole.find(
      (item) => String(item.org_id) === String(option.value),
    );
    setOrgSelete?.(org);
  };

  const searchText = watch("searchList");
  const selectedOrg = watch("selectedOrg");

  const offset = useMemo(() => (page - 1) * limit, [page, limit]);

  // ================= Fetch =================
  const fetchLocations = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = {
        limit,
        offset,
        ...(searchText ? { search: searchText } : {}),
        ...(activeTab === "orgs" && selectedOrg
          ? {
              orgId: Number(selectedOrg?.value),
              onlyAssign: true,
            }
          : {}),
        // ...(selectedOrg ? { orgId: Number(selectedOrg) } : {}),
      };

      const response = await getLocationOrgs(params);

      if (!response?.status || !Array.isArray(response?.result)) {
        setLocations([]);
        setTotalRows(0);
        return;
      }

      setLocations(response.result);
      setTotalRows(Number(response.total) || 0);

      // สร้าง org list จาก result (ครั้งแรก)
      if (!selectedOrg && page === 1) {
        const map = new Map();
        response.result.forEach((loc) => {
          const id = loc.office_location_id;
          if (!map.has(id)) {
            map.set(id, {
              id,
              nameEn: loc.office_location_name_en,
              nameTh: loc.office_location_name,
            });
          }
        });
        setOrganizations(Array.from(map.values()));
      }
    } catch (err) {
      console.error("Fetch locations error:", err);
      setLocations([]);
      setTotalRows(0);
    } finally {
      setIsLoading(false);
    }
  }, [limit, offset, searchText, selectedOrg, page, activeTab]);

  // reset page เมื่อ filter เปลี่ยน
  useEffect(() => {
    setPage(1);
  }, [searchText, selectedOrg, activeTab]);

  useEffect(() => {
    if (activeTab === "general") {
      fetchLocations();
      return;
    }

    if (activeTab === "orgs" && selectedOrg) {
      fetchLocations();
    }
  }, [page, activeTab, selectedOrg, fetchLocations]);

  const handleAddLocation = useCallback(() => {
    navigate("/setting/location/detail");
  }, [navigate]);

  const handleAssign = useCallback(() => {
    const params = new URLSearchParams();
    if (activeTab) {
      params.set("at", activeTab);
    }
    if (selectedOrg?.value) {
      params.set("o", selectedOrg.value);
    }
    navigate(
      `${PAGE_SETTING_LOCATION_ASSIGN}${
        params.toString() ? `?${params.toString()}` : ""
      }`,
    );
  }, [navigate, selectedOrg, activeTab]);

  const handleEditLocation = useCallback(
    (id, activeTab) => {
      const params = new URLSearchParams();
      params.set("id", id);
      if (activeTab) {
        params.set("at", activeTab);
      }
      if (selectedOrg?.value) {
        params.set("o", selectedOrg.value);
      }
      navigate(`/setting/location/detail?${params.toString()}`);
    },
    [navigate, selectedOrg],
  );

  const columns = [
    {
      header: t("hrms_setting_location_name_header"),
      minWidth: "384px",
      headerStyle: { textAlign: "left", verticalAlign: "middle" },
    },
    {
      header: t("hrms_setting_location_header"),
      minWidth: "196px",
      headerStyle: { textAlign: "left", verticalAlign: "middle" },
    },
    {
      header: t("hrms_setting_location_radius_header"),
      className: "text-center",
      minWidth: "118px",
      headerStyle: { textAlign: "center", verticalAlign: "middle" },
    },
    {
      header: t("hrms_setting_location_remark_header"),
      minWidth: "250px",
      headerStyle: { textAlign: "left", verticalAlign: "middle" },
    },
    {
      header: t("hrms_setting_location_status_header"),
      className: "text-center",
      minWidth: "86px",
      headerStyle: { textAlign: "center", verticalAlign: "middle" },
    },
    {
      header: t("hrms_setting_location_action_header"),
      className: "text-center",
      minWidth: "118px",
      headerStyle: { textAlign: "center", verticalAlign: "middle" },
    },
  ];

  const handleDownloadLocation = async () => {
    try {
      setDownloadIsLoading(true);

      const response = await downloadLocationOrgs({
        ...(searchText ? { search: searchText } : {}),
        ...(activeTab === "orgs" && selectedOrg
          ? {
              orgId: Number(selectedOrg?.value),
              onlyAssign: true,
            }
          : {}),
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const disposition = response.headers["content-disposition"];
      let fileName = "download.xlsx";

      if (disposition) {
        const match = disposition.match(/filename="(.+)"/);
        if (match?.[1]) fileName = match[1];
      }

      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setDownloadIsLoading(false);
    }
  };

  // ================= Render =================
  return (
    <div>
      {/* <div style={containerStyle(isDesktop)}> */}
      <NavTitle>
        <TextNavTitle>{t("hrms_setting_location_topic")}</TextNavTitle>
      </NavTitle>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        tabs={[
          { key: "poi", label: t("hrms_setting_location_poi") },
          { key: "general", label: t("hrms_setting_location_master") },
          { key: "orgs", label: t("hrms_setting_location_org") },
        ]}
      />
      {/* {activeTab === "general" && <LocationGeneral />}
      {activeTab === "orgs" && <LocationOrgs />} */}
      {activeTab === "general" && (
        <CardStyle
          style={{ ...cardStyleList(), padding: 0, marginTop: "24px" }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            {/* ===== Filter + Add + Table ===== */}
            <div>
              <Row className="mb-3" style={{ padding: "24px 24px 0px 24px", gap: isMobile ? 12 : 0 }}>
                <Col md={7} xs={12}>
                  {locationListFields("list", organizations).map((field) => (
                    <FormField
                      key={field.name}
                      {...field}
                      placeholder={t("hrms_setting_location_search")}
                      control={control}
                      errors={errors}
                      icon={field.icons}
                    />
                  ))}
                </Col>
                <Col
                  // xl={7}
                  // lg={7}
                  md={4}
                  // sm={12}
                  xs={12}
                  style={{
                    display: "flex",
                    gap: 12,
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    onClick={handleDownloadLocation}
                    style={{
                      width: isMobile ? "100%" : "fit-content",
                      height: 40,
                      padding: "0 16px",
                      border: "1px solid var(--color-on-base-border-default)",
                      backgroundColor:
                        "var(--color-base-foreground-elevated-16)",
                      color: "var(--color-on-base-content-high)",
                      borderRadius: 8,
                      fontSize: 14,
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                      cursor: "pointer",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                    disabled={downloadIsLoading}
                  >
                    <LuTable2 style={{ marginTop: "1px" }} />
                    {t("hrms_setting_location_export_bt")}
                  </Button>
                </Col>
                <Col
                  // xl={7}
                  // lg={7}
                  md={1}
                  // sm={12}
                  xs={12}
                  style={{
                    display: "flex",
                    // gap: 12,
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    onClick={handleAddLocation}
                    style={{
                      width: isMobile ? "100%" : "fit-content",
                      height: 40,
                      padding: "0 16px",
                      border: "1px solid var(--color-primary-border-default)",
                      backgroundColor:
                        "var(--comp-btn-color-background-secondary-normal)",
                      color: "var(--color-primary-content-default)",
                      borderRadius: 8,
                      fontSize: 14,
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                      cursor: "pointer",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    <HiOutlinePlus style={{ marginTop: "1px" }} />{" "}
                    {t("hrms_setting_location_add_bt")}
                  </Button>
                </Col>
              </Row>

              {/* ===== Table ===== */}
              <div
                style={{
                  flex: 1,
                  height: "calc(100vh - 330px)",
                  overflow: "auto",
                }}
              >
                <GenericTable
                  data={locations}
                  columns={columns}
                  isLoading={isLoading}
                  rowStartIndex={(page - 1) * limit}
                  renderRow={(location, index, borderStyle) =>
                    renderLocationRow(
                      location,
                      index,
                      borderStyle,
                      handleEditLocation,
                      activeTab,
                      t,
                    )
                  }
                  visible_rows={10}
                />
              </div>
            </div>

            {/* ===== Pagination ===== */}
            {/* <div style={{ marginTop: "auto" }}>
              <GenericPagination
                currentPage={page}
                totalItems={totalRows}
                itemsPerPage={limit}
                onPageChange={setPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                itemsPerPageOptions={[10, 25, 50, 100]}
                maxPagesToShow={5}
                showInfo={false}
                showItemsPerPage
                size="sm"
              />
            </div> */}
            <div
              style={{
                flexShrink: 0,
                borderTop: "1px solid var(--color-base-border-default)",
                padding: "0px 12px",
                boxShadow:
                  "0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: 16,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      color: "var(--color-on-base-content-low)",
                      fontSize: 14,
                    }}
                  >
                    {t("hrms_setting_location_row_page")}
                    {/* {t("tb_text_page")} */}
                  </span>
                  <Select
                    className="custom-select-color"
                    value={limit}
                    onChange={(limit) => {
                      setPage(1);
                      setLimit(limit);
                      // fnGetAllApproveList({
                      //   ...bodyFilter,
                      //   limit,
                      //   page: 1,
                      // });
                    }}
                    bordered={false}
                    size="small"
                    style={{
                      width: 80,
                      color: `var(--color-on-base-content-low)`,
                    }}
                    suffixIcon={
                      <TbChevronDown
                        size={22}
                        style={{
                          strokeWidth: 1.5,
                        }}
                        color={`var(--color-on-base-content-low)`}
                      />
                    }
                    options={[10, 20, 50, 100].map((n) => ({
                      value: n,
                      label: String(n),
                    }))}
                  />
                </div>
                <Pagination
                  size="small"
                  current={page}
                  pageSize={limit}
                  total={totalRows}
                  showSizeChanger={false}
                  onChange={(p) => {
                    setPage(p);
                    // fnGetAllApproveList({
                    //   ...bodyFilter,
                    //   page: p,
                    // });
                  }}
                />
              </div>
            </div>
          </div>
        </CardStyle>
      )}
      {activeTab === "orgs" && (
        <CardStyle
          style={{ ...cardStyleList(), padding: 0, marginTop: "25px" }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            {/* ===== Filter + Add + Table ===== */}
            <div>
              <Row
                style={{
                  // display: "flex",
                  gap: 12,
                  // alignItems: "center",
                  marginBottom: 16,
                  padding: "24px 24px 0px 24px",
                }}
              >
                <Col xl={7} style={{ flex: 1 }}>
                  <Row className="gap-3 gap-xl-0">
                    <Col xl={4}>
                      <FormField
                        type="select"
                        name="selectedOrg"
                        placeholder="Organizations"
                        control={control}
                        errors={errors}
                        required
                        options={orgRole.map((org) => ({
                          label: org.org,
                          value: org.org_id,
                        }))}
                        onChange={handleChangeOrg}
                      />
                    </Col>
                    <Col xl={8}>
                      {locationListFields("list", organizations).map(
                        (field) => (
                          <FormField
                            key={field.name}
                            placeholder={t("hrms_setting_location_search")}
                            {...field}
                            control={control}
                            errors={errors}
                            icon={field.icons}
                          />
                        ),
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col xl={6} className="d-flex justify-content-end">
                  <Button
                    onClick={handleAssign}
                    style={{
                      height: 40,
                      padding: "0 16px",
                      borderColor: "var(--color-primary-border-default)",
                      backgroundColor:
                        "var(--comp-btn-color-background-secondary-normal",
                      color: "var(--color-primary-content-default)",
                      borderRadius: 8,
                      fontSize: 14,
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                    }}
                  >
                    <RxCopy size={16} /> {t("hrms_setting_location_assign_bt")}
                  </Button>
                </Col>
              </Row>

              {/* ===== Table ===== */}
              <div
                style={{
                  flex: 1,
                  height: "calc(100vh - 330px)",
                  overflow: "auto",
                }}
              >
                <GenericTable
                  data={locations}
                  columns={columns}
                  isLoading={isLoading}
                  rowStartIndex={(page - 1) * limit}
                  renderRow={(location, index, borderStyle) =>
                    renderLocationRow(
                      location,
                      index,
                      borderStyle,
                      handleEditLocation,
                      activeTab,
                      t,
                    )
                  }
                  visible_rows={10}
                  activeTab={activeTab}
                />
              </div>
            </div>

            {/* ===== Pagination ===== */}
            {/* <div style={{ marginTop: "auto" }}>
              <GenericPagination
                currentPage={page}
                totalItems={totalRows}
                itemsPerPage={limit}
                onPageChange={setPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                itemsPerPageOptions={[10, 25, 50, 100]}
                maxPagesToShow={5}
                showInfo={false}
                showItemsPerPage
                size="sm"
              />
            </div> */}
            <div
              style={{
                flexShrink: 0,
                borderTop: "1px solid var(--color-base-border-default)",
                padding: "0px 12px",
                boxShadow:
                  "0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: 16,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      color: "var(--color-on-base-content-low)",
                      fontSize: 14,
                    }}
                  >
                    {t("hrms_setting_location_row_page")}
                    {/* {t("tb_text_page")} */}
                  </span>
                  <Select
                    className="custom-select-color"
                    value={limit}
                    onChange={(limit) => {
                      setPage(1);
                      setLimit(limit);
                      // fnGetAllApproveList({
                      //   ...bodyFilter,
                      //   limit,
                      //   page: 1,
                      // });
                    }}
                    bordered={false}
                    size="small"
                    style={{
                      width: 60,
                      color: `var(--color-on-base-content-low)`,
                    }}
                    suffixIcon={
                      <TbChevronDown
                        size={22}
                        style={{
                          strokeWidth: 1.5,
                        }}
                        color={`var(--color-on-base-content-low)`}
                      />
                    }
                    options={[10, 20, 50, 100].map((n) => ({
                      value: n,
                      label: String(n),
                    }))}
                  />
                </div>
                <Pagination
                  size="small"
                  current={page}
                  pageSize={limit}
                  total={totalRows}
                  showSizeChanger={false}
                  onChange={(p) => {
                    setPage(p);
                    // fnGetAllApproveList({
                    //   ...bodyFilter,
                    //   page: p,
                    // });
                  }}
                />
              </div>
            </div>
          </div>
        </CardStyle>
      )}
      {activeTab === "poi" && (
        <CardStyle
          style={{ ...cardStyleList(), padding: 0, marginTop: "25px" }}
        >
          <LocationPOI />
        </CardStyle>
      )}
    </div>
  );
};

export default Location;
